/**
 * Auth Context - Vorbereitet für zukünftige Login-Funktionalität
 * 
 * Zukünftige Features:
 * - Login / Logout
 * - Benutzerkonten
 * - Geschützte Bereiche (Förderer, Mitglieder)
 * - Rollen und Rechte (admin, foerderer, mitglied, gast)
 * - Persönliche Dokumente und Kommunikation
 */

import React, { createContext, useContext, useState, useEffect } from 'react';

// Benutzerrollen für zukünftige Implementierung
export const USER_ROLES = {
  GUEST: 'guest',
  MEMBER: 'mitglied',
  FOERDERER: 'foerderer',
  ADMIN: 'admin',
};

// Initial State
const initialState = {
  user: null,
  isAuthenticated: false,
  isLoading: true,
  role: USER_ROLES.GUEST,
};

const AuthContext = createContext(initialState);

export function AuthProvider({ children }) {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    // Zukünftig: Prüfe bestehende Session
    // Aktuell: Setze loading auf false
    setState(prev => ({ ...prev, isLoading: false }));
  }, []);

  // Zukünftige Funktionen (aktuell Platzhalter)
  const login = async (email, password) => {
    // TODO: Implementierung mit Backend
    console.log('Login-Funktion vorbereitet für:', email);
    return { success: false, message: 'Login wird in einer zukünftigen Version aktiviert.' };
  };

  const logout = async () => {
    // TODO: Implementierung mit Backend
    setState({ ...initialState, isLoading: false });
  };

  const register = async (userData) => {
    // TODO: Implementierung mit Backend
    console.log('Registrierung vorbereitet für:', userData);
    return { success: false, message: 'Registrierung wird in einer zukünftigen Version aktiviert.' };
  };

  // Prüft ob Benutzer bestimmte Rolle hat
  const hasRole = (requiredRole) => {
    if (!state.isAuthenticated) return false;
    const roleHierarchy = [USER_ROLES.GUEST, USER_ROLES.MEMBER, USER_ROLES.FOERDERER, USER_ROLES.ADMIN];
    const userRoleIndex = roleHierarchy.indexOf(state.role);
    const requiredRoleIndex = roleHierarchy.indexOf(requiredRole);
    return userRoleIndex >= requiredRoleIndex;
  };

  const value = {
    ...state,
    login,
    logout,
    register,
    hasRole,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export default AuthContext;
